import { useNavigate, useLocation } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { RESET_PASSWORD_ORG_USER } from "../../graphql/mutations/signUp";
import { useDispatch, useSelector } from "react-redux";
import { loginAction, setError, setLoading } from "../../store/auth/authSlice";
import { useEffect, useState } from "react";
import { RootState } from "../../store/rootReducer";
import { LoadingSpinner, Overlay } from "../AddUserPage/AddUser";
import { toast } from "react-toastify";
import { setUserData } from "../../store/user";
import { clearStorage } from "../../store";
import ResetPasswordOrgUser from "../../components/ForgotPassword/ResetPasswordOrgUser";

export interface ResetPasswordOrgUserFormValues {
  newPassword: string;
}

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const ResetPasswordOrgUserPage: React.FC = () => {
  const [reloadCount, setReloadCount] = useState<number>(0);
  const query = useQuery();
  const token = query.get("token");
  const [resetPasswordOrgUser, { loading }] = useMutation(
    RESET_PASSWORD_ORG_USER,
    {
      errorPolicy: "all",
    }
  );
  const [formData, setFormData] = useState<ResetPasswordOrgUserFormValues>({
    newPassword: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleResetPassword = async () => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(""));
      const response = await resetPasswordOrgUser({
        variables: {
          newPassword: formData.newPassword,
          token: token,
        },
      });

      if (response.data.resetPasswordOrgUser.success === true) {
        const { success, message } = response.data.resetPasswordOrgUser;

        dispatch(
          setUserData({
            success,
            message,
          })
        );
        toast.success(
          "Password reset successful. Please login with your new password."
        );
        navigate("/auth/login");
      } else {
        dispatch(setError("Reset Password failed. Please try again."));
        toast.error("Reset Password failed. Please try again.");
      }
    } catch (error: any) {
      const message = `Reset Password failed. Please try again.`;
      dispatch(setError(message));
      toast.error(message);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      {loading && (
        <Overlay>
          <LoadingSpinner />
        </Overlay>
      )}
      <ResetPasswordOrgUser
        handleResetPassword={handleResetPassword}
        formData={formData}
        setFormData={setFormData}
        isLoading={loading}
      />
    </>
  );
};

export default ResetPasswordOrgUserPage;
